module.exports = __webpack_public_path__ + "img/shihezi-35453d.png";